import Vue from "vue";
import Vuex from "vuex";
import access from "./modules/access";
import accountWhitelabel from "./modules/accountWhitelabel";
import advertisers from "./modules/advertisers";
import advertising from "./modules/advertising";
import alertproblem from "./modules/alertproblem";
import answeradvertising from "./modules/answeradvertising";
import audit from "./modules/audit";
import captiveStyle from "./modules/captiveStyle";
import comments from "./modules/comments";
import connections from "./modules/connections";
import devices from "./modules/devices";
import establishments from "./modules/establishments";
import freeconnections from "./modules/freeconnections";
import integration from "./modules/integration";
import integrationsreport from "./modules/integrationsreport";
import interactions from "./modules/interactions";
import ipfirewall from "./modules/ipfirewall";
import layout from "./modules/layout";
import leads from "./modules/leads";
import local from "./modules/local";
import marketing from "./modules/marketing";
import promocionalcode from "./modules/promocionalcode";
import statistics from "./modules/statistics";
import systemWarning from "./modules/systemWarning";
import tag from "./modules/tag";
import trackers from "./modules/trackers";
import users from "./modules/users";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    advertisers,
    advertising,
    devices,
    establishments,
    users,
    leads,
    integrationsreport,
    statistics,
    comments,
    interactions,
    connections,
    freeconnections,
    answeradvertising,
    integration,
    promocionalcode,
    alertproblem,
    access,
    tag,
    trackers,
    ipfirewall,
    audit,
    systemWarning,
    local,
    marketing,
    layout,
    captiveStyle,
    accountWhitelabel
  },

  state: {
    loading: 0,
  },

  mutations: {
    SET_LOADING: (state) => {
      state.loading++;
    },

    SET_LOADED: (state) => {
      state.loading--;
    },
  },
});

export default store;
